import 'semantic-ui-css/components/reset.css'
import 'semantic-ui-css/components/site.css'
import 'semantic-ui-css/components/button.css'
import 'semantic-ui-css/components/checkbox.css'
import 'semantic-ui-css/components/container.css'
import 'semantic-ui-css/components/divider.css'
import 'semantic-ui-css/components/dropdown.css'
import 'semantic-ui-css/components/form.css'
import 'semantic-ui-css/components/grid.css'
import 'semantic-ui-css/components/header.css'
import 'semantic-ui-css/components/icon.css'
import 'semantic-ui-css/components/image.css'
import 'semantic-ui-css/components/input.css'
import 'semantic-ui-css/components/label.css'
import 'semantic-ui-css/components/list.css'
import 'semantic-ui-css/components/loader.css'
import 'semantic-ui-css/components/menu.css'
import 'semantic-ui-css/components/message.css'
import 'semantic-ui-css/components/search.css'
import 'semantic-ui-css/components/segment.css'
import 'semantic-ui-css/components/step.css'
import 'semantic-ui-css/components/sticky.css'
import 'semantic-ui-css/components/tab.css'
import 'semantic-ui-css/components/transition.css'
import 'semantic-ui-css/components/popup.css'
import 'semantic-ui-css/components/table.css'
import 'semantic-ui-css/components/flag.css'

// import 'semantic-ui-css/semantic.min.css'
import './index.styl'

import Rollbar from 'rollbar'
import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../components/header'
import Footer from '../components/footer'
import ogImage from '../../static/opengraph-image.jpg'
import { withPrefix } from 'gatsby-link'

const isSSR = (() => {
  return typeof window === 'undefined'
})()

// {(window.location.hostname === 'localhost') ? data.site.siteMetadata.title = '' : null}
const Layout = ({ children, data, location, ...rest }) => (
  <React.Fragment>
    <Helmet>
      {isSSR ? (
        <title>
          ✈️ {data.site.siteMetadata.title} 👍 — Generate Proof of Onward Travel
        </title>
      ) : (
        <title>
          Fake Flight Ticket Generator — Proof of Onward Travel - (almost free)
        </title>
      )}
      <link rel='shortcut icon' type='image/png' href={withPrefix('/favicon.png')} />
      <meta property='og:image:url' content={data.site.siteMetadata.siteUrl + ogImage} />
      <meta property='og:image' content={data.site.siteMetadata.siteUrl + ogImage} />
      <meta
        name='keywords'
        content='fake ticket generator,pdf ticket,onward ticket,onward flight,fake flight ticket, proof of onward travel'
      />
      <meta
        name='description'
        content='Real flight data. Present it as proof of onward travel and you are ready for your one-way flight. $5 Only - Almost free! Does not contain PNR.'
      />
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={data.site.siteMetadata.title} />
      <meta name='twitter:description' content={data.site.siteMetadata.description} />
      <meta name='twitter:image' content={data.site.siteMetadata.siteUrl + ogImage} />

      <link
        rel='alternate'
        href={data.site.siteMetadata.siteUrl + '/ru' + location.pathname}
        hreflang='ru-ru'
      />
      <link
        rel='alternate'
        href={data.site.siteMetadata.siteUrl + location.pathname}
        hreflang='x-default'
      />

      <script type='application/ld+json'>
        {`{
          "@context" : "http://schema.org",
          "@type" : "Website",
          "name" : "${data.site.siteMetadata.title}",
          "description": "${data.site.siteMetadata.description}",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "9.8",
            "bestRating": "10",
            "ratingCount": "869"
          }
        }`}
      </script>
      <script type='text/javascript'>
        {/* PayPal Store Cash Campaign */}
        {`(function(a,t,o,m,s){a[m]=a[m]||[];a[m].push({t:new Date().getTime(),event:'snippetRun'});var f=t.getElementsByTagName(o)[0],e=t.createElement(o),d=m!=='paypalDDL'?'&m='+m:'';e.async=!0;e.src='https://www.paypal.com/tagmanager/pptm.js?id='+s+d;f.parentNode.insertBefore(e,f);})(window,document,'script','paypalDDL','efdf3ee9-c470-42d7-817e-220f8a88fd21');`}
      </script>
      <script type='text/javascript'>
        {/* Hotjar Tracking */}
        {/*`(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:1446717,hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`*/}
      </script>
      <script type='text/javascript'>
        {/* Inspectlet */}
        {/*`(function() {window.__insp = window.__insp || [];__insp.push(['wid', 1482100008]);var ldinsp = function(){if(typeof window.__inspld != "undefined") return; window.__inspld = 1; var insp = document.createElement('script'); insp.type = 'text/javascript'; insp.async = true; insp.id = "inspsync"; insp.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js?wid=1482100008&r=' + Math.floor(new Date().getTime()/3600000); var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(insp, x); };setTimeout(ldinsp, 0);})();`*/}

        {/* HoverSignal */}
        {/*`(function (d, w) {var n = d.getElementsByTagName("script")[0],s = d.createElement("script"),f = function () { n.parentNode.insertBefore(s, n); };s.type = "text/javascript";s.async = true;s.src = "https://app.hoversignal.com/Api/Script/a1d0c169-309b-48a1-b64a-e3c87f2007bf";if (w.opera == "[object Opera]") {  d.addEventListener("DOMContentLoaded", f, false);} else { f(); }})(document, window);`*/}
      </script>
      <script src='https://cdn.tailwindcss.com'></script>
    </Helmet>
    <Header siteTitle={data.site.siteMetadata.title} location={location} />
    {children()}
    <Footer />
  </React.Fragment>
)

Layout.propTypes = {
  children: PropTypes.func,
}

if (!isSSR) {
  window._rollb = new Rollbar({
    accessToken: 'd983df8e8bac41be9b3389d01d980f03',
    captureUncaught: true,
    captureUnhandledRejections: true,
  })
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
        siteUrl
        description
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js